export enum OnboardingStep {
    None = 0,
    SwitchLocation = 1,
    SelectLocation = 2,
    ChooseTile = 3,
    WrongMatch = 4,
    SavePrint = 5,
    GoHome = 6,
}
